import { To } from "react-router";

/**
 * Extracts the pathname from a route target, stripping any search/query params.
 * e.g. "/notes/123?settings=zapier-page" → "/notes/123"
 */
export const parseRoutingPathname = (to: To | undefined): string => {
  if (typeof to === "string") {
    const queryIndex = to.indexOf("?");
    return queryIndex >= 0 ? to.substring(0, queryIndex) : to;
  }

  return to?.pathname ?? "/";
};
